import { FC } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { PositiveMenuItem } from './positiveMenuItem'
import { NegativeMenuItem } from './negativeMenuItem'
import { menuItems } from '.'
import { Header1 } from '@tuhi/components'
import { useSignOut } from 'app/hooks/useSignOut'
import { useMobileMenu } from 'app/hooks/useMobileMenu'
import { media } from '@tuhi/components/src/theme/breakpoints'

import SignOutIcon from '@tuhi/components/assets/icons/navigationMenu/signOut.svg'

const Overlay = styled.div<{ $isOpen: boolean }>`
    display: none;

    ${media.mobile} {
        display: ${(p) => (p.$isOpen ? 'block' : 'none')};
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
    }
`

const Backdrop = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
`

const Panel = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 280px;
    max-width: 80vw;
    background-color: ${(p) => p.theme.colors.tertiary.default};
    border-right: ${(p) => `2px solid ${p.theme.colors.tertiary.tertiary50}`};
    display: flex;
    flex-direction: column;
    padding: 32px;
    overflow-y: auto;
    z-index: 1;
`

const Title = styled(Header1)`
    text-align: center;
    margin-bottom: 40px;
`

const Section = styled.div`
    display: flex;
    flex-direction: column;
`

const TopSection = styled(Section)`
    flex: 1;
`

const BottomSection = styled(Section)``

export const MobileSideMenu: FC = () => {
    const { isOpen, close } = useMobileMenu()
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const signOut = useSignOut()

    const handleNavItemClick = (path: string) => {
        navigate(path)
        close()
    }

    const handleSignOut = () => {
        close()
        signOut()
    }

    return (
        <Overlay $isOpen={isOpen}>
            <Backdrop onClick={close} />
            <Panel>
                <Title>Tuhi</Title>

                <TopSection>
                    {menuItems.topSection.map((menu) => (
                        <PositiveMenuItem
                            key={menu.route.name}
                            menu={menu}
                            isSelected={menu.route.match(pathname)}
                            isCollapsed={false}
                            onNavigate={() =>
                                handleNavItemClick(menu.route.path)
                            }
                        />
                    ))}
                </TopSection>

                <BottomSection>
                    {menuItems.bottomSection.map((menu) => (
                        <PositiveMenuItem
                            key={menu.route.name}
                            menu={menu}
                            isSelected={menu.route.match(pathname)}
                            isCollapsed={false}
                            onNavigate={() =>
                                handleNavItemClick(menu.route.path)
                            }
                        />
                    ))}

                    <NegativeMenuItem
                        key="Sign out"
                        icon={<SignOutIcon />}
                        text="Sign out"
                        onClick={handleSignOut}
                        isCollapsed={false}
                    />
                </BottomSection>
            </Panel>
        </Overlay>
    )
}
